/*
 * @Author: Dom
 * @Date: 2022-07-28 14:19:46
 * @LastEditTime: 2022-07-30 11:46:32
 * @LastEditors: Dom
 * @FilePath: \seller-web\src\store\userstatus.ts
 */
import { Mutation, Action } from 'vuex';
import { StoreModuleType } from "@/utils/store";
import { ResponseData } from '@/utils/request';
import {checkUserStatus,checkAccountStatus} from '@/services/userstatus'
import {UserInfoParams} from '@/services/data.d'


export interface StateType {
    errorMsg?: string;
    info: any;
    accinfo: any;
}

export interface ModuleType extends StoreModuleType<StateType>{
    state: StateType;
    mutations: {
        changeErrorMsg: Mutation<StateType>;
        setinfo: Mutation<StateType>;
        setaccinfo: Mutation<StateType>;
    },
    actions: {
        checkUserStatusFn: Action<StateType,StateType>
        checkAccountStatusFn: Action<StateType,StateType>
    }
}

const initState: StateType = {
    errorMsg: undefined,
    info:{
        body: false,
        msg: ''
    },
    accinfo: {
        body: false,
        msg: ''
    },
}

const StoreModel: ModuleType = {
    namespaced: true,
    name: 'userstatus',
    state: {
        ...initState
    },
    mutations: {
        changeErrorMsg(state, payload) {
            state.errorMsg = payload;
        },
        setinfo(state, payload) {
            state.info = payload;
        },
        setaccinfo(state, payload) {
            state.accinfo = payload;
        },
    },
    actions: {
        //获取帐号状态
        async checkUserStatusFn({ commit },params:UserInfoParams){
            let msg: string | undefined = undefined
            try{
                const req:ResponseData = await checkUserStatus(params)
                const infomsg = {
                    body: req.body,
                    msg: req.msg
                }
                commit('setinfo', infomsg)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        },
        //获取账户状态
        async checkAccountStatusFn({ commit },params:UserInfoParams){
            let msg: string | undefined = undefined
            try{
                const req:ResponseData = await checkAccountStatus(params)
                const infomsg = {
                    body: req.body,
                    msg: req.msg
                }
                commit('setaccinfo', infomsg)
                msg = '';
            }catch(error:any){
                if (error.message && error.message === 'CustomError') {
                    const { response } = error;
                    const { data } = response;
                    msg = data.msg || 'error';
                }
            }
            commit('changeErrorMsg',msg);
            if (msg === '') {
                return true; // 成功
            } else if (typeof msg === 'undefined') {
                return undefined; // 服务器错误
            } else {
                return false; // 自定义错误
            }
        }
    }
}

export default StoreModel
